import angular from "angular";
import panel from "../services";

function socialLogin(panel){

    return {
        restrict: 'A',

        link: function(scope, element, attr) {

            const FACEBOOK_APP_ID = panel.getConfig().FACEBOOK_APP_ID;
            let authorized = false;
            let fields = 'id,about,birthday,education,email,favorite_athletes,favorite_teams,' +
                'name,relationship_status,religion,sports,timezone,first_name,last_name,link,locale,' +
                'meeting_for,gender,picture.type(large),friends';

            let fb_API = function() {
                FB.api('/me', {fields: fields}, function(response){
                    panel.post('/v1/account/social', {type:'facebook', facebook:response}, function(response){
                        if(response.redirect){
                            location.href = response.redirect;
                        }
                        else if(response.Error){
                            panel.alert(response.Error);
                        }
                    });
                });
            };

            let statusChangeCallback = function (response) {
                if(response.status === 'connected') authorized = true;
                else if (response.status === 'not_authorized' || response.status === 'unknown' || response.authResponse == 'undefined'){}
                if(authorized) fb_API();
                return authorized;
            };

            window.fbAsyncInit = function () {
                FB.init({appId:FACEBOOK_APP_ID,xfbml:true,version:'v3.3'});
            };

            panel.loadFacebook();

            $(element).click(() => {
                FB.getLoginStatus((response) => {
                    let status = statusChangeCallback(response);
                    if(!status) {
                        FB.login((response) => {
                            if (response.authResponse) {
                                // console.log('Welcome!  Fetching your information.... ');
                                fb_API();
                            } else {
                                // console.log('User cancelled login or did not fully authorize.');
                            }
                        })
                    }
                });
            });
        }
    }
}

export default angular.module('directives.socialLogin', [panel]).directive('socialLogin', socialLogin).name;



// WEBPACK FOOTER //
// ./src/app/directives/socialLogin.js